import { Users, TrendingUp, Bookmark } from 'lucide-react'
import { SidebarSection } from './sidebar-section'
import { SidebarItem } from './sidebar-item'

interface SavedItemsSectionProps {
  sidebarCollapsed: boolean
  onItemClick: () => void
}

export function SavedItemsSection({ sidebarCollapsed, onItemClick }: SavedItemsSectionProps) {
  const savedItems = [
    { name: 'Saved Accounts', href: '/saved-accounts', icon: Users },
    { name: 'Saved Trends', href: '/saved-trends', icon: TrendingUp },
  ]

  return (
    <SidebarSection
      title="Saved Items"
      icon={<Bookmark className="h-4 w-4" />}
      sidebarCollapsed={sidebarCollapsed}
      defaultOpen={false}
      collapsible={true}
      expandsUpward={true}
    >
      {savedItems.map((item) => (
        <SidebarItem
          key={item.name}
          name={item.name}
          href={item.href}
          icon={item.icon}
          sidebarCollapsed={sidebarCollapsed}
          onClick={onItemClick}
        />
      ))}
    </SidebarSection>
  )
}
